var _path, _g, _g2, _circle, _rect, _path2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _g4, _circle2, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountRegisteredIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 120,
    viewBox: "0 0 222 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.696 0H82.3037C77.8964 1.77698e-06 73.5667 1.15842 69.7498 3.35883C65.933 5.55924 62.7635 8.7241 60.5598 12.5353L40.3638 47.4644C38.1601 51.2756 37 55.5989 37 59.9997C37 64.4005 38.1601 68.7238 40.3638 72.535L60.5598 107.465C62.7635 111.276 65.933 114.441 69.7498 116.641C73.5667 118.842 77.8964 120 82.3037 120H122.696C127.104 120 131.433 118.842 135.25 116.641C139.067 114.441 142.237 111.276 144.44 107.465L164.636 72.535C166.84 68.7238 168 64.4005 168 59.9997C168 55.5989 166.84 51.2756 164.636 47.4644L144.44 12.5353C142.237 8.7241 139.067 5.55924 135.25 3.35883C131.433 1.15842 127.104 1.77698e-06 122.696 0Z",
    fill: "url(#paint0_linear_6698_24140)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6698_24140)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 102,
    width: 76,
    height: 108,
    rx: 8,
    transform: "rotate(-90 37 102)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.75,
    y: 101.25,
    width: 74.5,
    height: 106.5,
    rx: 7.25,
    transform: "rotate(-90 37.75 101.25)",
    stroke: "#254E5F",
    strokeWidth: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_6698_24140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 56,
    r: 19,
    fill: "#EDF0F2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 56,
    r: 19,
    stroke: "#254E5F",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.75,
    y: 32.75,
    width: 19.5,
    height: 1.5,
    rx: 0.75,
    fill: "#C7C7CC",
    stroke: "#254E5F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3126 50.4348C60.3126 48.9505 61.5158 47.7473 63.0001 47.7473C64.4844 47.7473 65.6876 48.9505 65.6876 50.4348C65.6876 51.9191 64.4844 53.1223 63.0001 53.1223C61.5158 53.1223 60.3126 51.9191 60.3126 50.4348ZM63.0001 46.2473C60.6874 46.2473 58.8126 48.1221 58.8126 50.4348C58.8126 52.7475 60.6874 54.6223 63.0001 54.6223C65.3128 54.6223 67.1876 52.7475 67.1876 50.4348C67.1876 48.1221 65.3128 46.2473 63.0001 46.2473ZM61.4346 56.8724C58.2589 56.8724 55.6846 59.4467 55.6846 62.6224V64.3164C55.6846 64.7306 56.0204 65.0664 56.4346 65.0664C56.8488 65.0664 57.1846 64.7306 57.1846 64.3164V62.6224C57.1846 60.2752 59.0874 58.3724 61.4346 58.3724H64.8128C64.8146 58.3724 64.8165 58.3724 64.8183 58.3724C65.647 58.3724 66.4203 58.6096 67.074 59.0197C67.3442 59.1947 67.5948 59.4028 67.8192 59.6414C67.8613 59.6862 67.9076 59.7246 67.9569 59.7567C68.6473 60.5124 69.0683 61.5182 69.0683 62.6224V64.3164C69.0683 64.7306 69.4041 65.0664 69.8183 65.0664C70.2326 65.0664 70.5683 64.7306 70.5683 64.3164V62.6224C70.5683 60.5655 69.4884 58.7609 67.8645 57.7447C66.9823 57.1801 65.9493 56.8724 64.8832 56.8724H61.4346Z",
    fill: "#254E5F"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6698_24140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 39,
    r: 26,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 39,
    r: 26,
    stroke: "#8BC34A",
    strokeWidth: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 44.5H125",
    stroke: "#254E5F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 53.5H131.5",
    stroke: "#254E5F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90 63H116",
    stroke: "#254E5F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 72H131.5",
    stroke: "#254E5F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 85H108",
    stroke: "#254E5F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 93H80",
    stroke: "#254E5F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 7,
    width: 17,
    height: 8,
    rx: 2,
    fill: "#D6D6D6",
    stroke: "#254E5F",
    strokeWidth: 1.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6698_24140)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 12,
    width: 17,
    height: 22,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 12,
    width: 17,
    height: 22,
    rx: 2,
    stroke: "#254E5F",
    strokeWidth: 1.5
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 19.5,
    r: 2.5,
    fill: "#D6D6D6",
    stroke: "#254E5F",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 47L153.76 47.6727C153.967 47.9005 154.268 48.0202 154.575 47.9972C154.882 47.9742 155.161 47.8109 155.332 47.5547L154.5 47ZM167.332 29.5547C167.638 29.0952 167.514 28.4743 167.055 28.1679C166.595 27.8616 165.974 27.9858 165.668 28.4453L167.332 29.5547ZM147.74 38.0773C147.368 37.6687 146.736 37.6386 146.327 38.0101C145.919 38.3816 145.889 39.014 146.26 39.4227L147.74 38.0773ZM155.332 47.5547L167.332 29.5547L165.668 28.4453L153.668 46.4453L155.332 47.5547ZM146.26 39.4227L153.76 47.6727L155.24 46.3273L147.74 38.0773L146.26 39.4227Z",
    fill: "#8BC34A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.037 79.036C129.043 78.6523 134.807 81.2975 130.924 88.7427C126.094 88.6798 124.475 92.45 120.926 90.4107C116.358 87.7858 120.469 79.4735 125.037 79.036Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99 94.348C113.16 88.6607 120.926 102.223 128.691 92.1606C136.457 82.0984 129.605 78.5985 125.037 79.036C120.469 79.4735 116.358 87.7858 120.926 90.4107C125.494 93.0356 126.864 86.0358 136 89.9732",
    stroke: "#488BCA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6698_24140",
    x: 33,
    y: 23,
    width: 116,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6698_24140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6698_24140",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_6698_24140",
    x: 43.25,
    y: 36.25,
    width: 39.5,
    height: 42.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6698_24140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6698_24140",
    x: 125,
    y: 10,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6698_24140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6698_24140",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6698_24140",
    x: 77.25,
    y: 8.25,
    width: 26.5,
    height: 31.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6698_24140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6698_24140",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6698_24140",
    x1: 37,
    y1: 120,
    x2: 156.54,
    y2: -10.4978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C9F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BA1A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountRegisteredIcon);
export default __webpack_public_path__ + "static/media/account-registered-icon.039e99ed66822bdbd3c01986f60f4855.svg";
export { ForwardRef as ReactComponent };